import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const holidaysApi = createApi({
  reducerPath: 'holidaysApi',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getAllHolidays: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/holiday/${params}`
      }),
      providesTags: ['getAllHolidays']
    }),
    updateHolidays: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/prepaid-engine/holiday`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['getAllHolidays']
    }),
    createOrUpdateHolidays: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/prepaid-engine/holiday/many`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['getAllHolidays']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllHolidaysQuery,
  useUpdateHolidaysMutation,
  useCreateOrUpdateHolidaysMutation
} = holidaysApi;
